import { Component, OnDestroy, OnInit } from "@angular/core";
import { ControlValueAccessor, FormBuilder, FormGroup } from "@angular/forms";
import { IntegratedAdmissionWizardService } from "../service/integrated-admission-wizard.service";
import { IntegratedAdmissionAppointment } from "src/app/model/integrated-admission/integrated-admission-appointment";
import { Subscription } from "rxjs";

@Component({
  selector: "app-integrated-admission-appointment",
  templateUrl: "./integrated-admission-appointment.component.html",
  styleUrls: ["./integrated-admission-appointment.component.css"],
})
export class IntegratedAdmissionAppointmentComponent
  implements OnInit, OnDestroy
{
  readonlySubscription: Subscription;
  currentAppointmentSubscription: Subscription;
  appointment: IntegratedAdmissionAppointment;
  existsCurrentInvoice: boolean;
  readonly: boolean;

  constructor(private service: IntegratedAdmissionWizardService) {}

  ngOnDestroy(): void {
    if (this.currentAppointmentSubscription) {
      this.currentAppointmentSubscription.unsubscribe();
    }
  }

  ngOnInit() {
    this.service.currentAdmissionAppointment$.subscribe((appointment) => {
      this.appointment = appointment;
      this.existsCurrentInvoice = appointment.ExistsCurrentInvoice;
    });

    this.readonlySubscription = this.service.currentReadOnlySubject$.subscribe(
      (readonly) => {
        if (readonly) {
          this.readonly = readonly;
        }
      }
    );
  }
}
